var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextBackIconTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "159C35C3-E841-410C-89F9-4BC342E472F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 31.5076923
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-order",
    transform: "translate(-1005, -312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(309, 296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-back-icon-teal",
    transform: "translate(696, 16.8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6,22.7117949 C11.35556,22.4711549 11.2333333,22.1647426 11.2333333,21.7928205 C11.2333333,21.4208985 11.35556,21.1144862 11.6,20.8738462 L16.8,15.7538462 L11.6,10.633833 C11.35556,10.3931405 11.2333333,10.0868201 11.2333333,9.71485867 C11.2333333,9.3428841 11.35556,9.03656369 11.6,8.79588431 C11.84444,8.55519179 12.15556,8.43485867 12.5333333,8.43485867 C12.9111067,8.43485867 13.2222267,8.55519179 13.4666667,8.79588431 L19.6,14.8348718 C19.7333333,14.9661538 19.8277333,15.1083323 19.8833333,15.2615385 C19.9389333,15.4147446 19.9666667,15.5788472 19.9666667,15.7538462 C19.9666667,15.9288451 19.9389333,16.0929477 19.8833333,16.2461538 C19.8277333,16.39936 19.7333333,16.5415385 19.6,16.6728205 L13.4666667,22.7117949 C13.2222267,22.9524349 12.9111067,23.0728205 12.5333333,23.0728205 C12.15556,23.0728205 11.84444,22.9524349 11.6,22.7117949 Z",
    id: "Path",
    fill: "#026D7C",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBackIconTeal);
export default __webpack_public_path__ + "static/media/next-back-icon-teal.a2273aa8fa41e3afd1978b2dfd06480c.svg";
export { ForwardRef as ReactComponent };